import type { GameState } from "./types";

/** account.tapReward stays the base: energy prices must not depend on boosts. */
export function tapBoostAt(state: Pick<GameState, "account" | "premium" | "season">, now: number) {
  const boosts = state.season.status !== "active" ? [] : state.premium.tapBoosts.filter((boost) =>
    Number.isSafeInteger(boost.multiplierBasisPoints) && boost.multiplierBasisPoints >= 10_000 &&
    Date.parse(boost.startsAt) < Date.parse(boost.endsAt) && Date.parse(boost.endsAt) > now);
  const active = boosts.filter((boost) => Date.parse(boost.startsAt) <= now)
    .sort((a, b) => b.multiplierBasisPoints - a.multiplierBasisPoints)[0];
  const queued = boosts.filter((boost) => Date.parse(boost.startsAt) > now)
    .sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt));
  const multiplierBasisPoints = active?.multiplierBasisPoints ?? 10_000;
  return {
    active, queued, multiplierBasisPoints,
    reward: (BigInt(state.account.tapReward) * BigInt(multiplierBasisPoints) / 10_000n).toString(),
    percent: (multiplierBasisPoints - 10_000) / 100,
  };
}

export function boostCountdown(endsAt: string, now: number): string {
  const seconds = Math.max(0, Math.ceil((Date.parse(endsAt) - now) / 1000));
  const hours = Math.floor(seconds / 3600);
  return `${hours > 0 ? `${hours}:` : ""}${String(Math.floor(seconds / 60) % 60).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
}
